module.exports = __webpack_public_path__ + "img/shipments.9c8efc57.svg";